import { TimeFrames } from '@shared/types/frontend/searchHome';
import FilterNetworkDropdown from './FilterNetworkDropDown';
import FilterTimeFrameSelector from './FilterTimeFrameSelector';
interface DFiltersControllerProps {
  setNetwork: (_: number[]) => void;
  network: number[];
  defaultNetwork: number[];
  timeFrame: TimeFrames;
  setTimeFrame: (_: TimeFrames) => void;
  customHandler?: boolean;
}
const DFiltersController = ({
  network,
  defaultNetwork,
  setNetwork,
  timeFrame,
  setTimeFrame,
  customHandler
}: DFiltersControllerProps) => {
  return <div className='w-fit h-[40px] flex gap-2 items-center bg-genius-indigo rounded-full px-[5px] py-[10px]' data-sentry-component="DFiltersController" data-sentry-source-file="DFiltersController.tsx">
      <FilterNetworkDropdown setNetwork={setNetwork} network={network} defaultNetwork={defaultNetwork} customHandler={customHandler} data-sentry-element="FilterNetworkDropdown" data-sentry-source-file="DFiltersController.tsx" />
      <FilterTimeFrameSelector timeFrame={timeFrame} setTimeFrame={setTimeFrame} customHandler={customHandler} data-sentry-element="FilterTimeFrameSelector" data-sentry-source-file="DFiltersController.tsx" />
    </div>;
};
export default DFiltersController;